import { InterviewSimulationsDetailsTranslation } from '@/assets/locales/views/interviewSimulations/details/interviewSimulationsDetails.translation.en.ts';

export const interviewSimulationsDetailsTranslation: InterviewSimulationsDetailsTranslation = {
  answer: 'Odpowiedź',
  buttons: {
    send: 'Wyślij',
  },
  knowMe: 'KnowMe',
  typeMessage: 'Wpisz odpowiedź...',
};
